module.exports = __webpack_public_path__ + "img/logout.f3831aaf.svg";